// extracted by mini-css-extract-plugin
export default {"self":"PerpetualMassesLayout-module--self--ZWC-z","footerWrapper":"PerpetualMassesLayout-module--footerWrapper--Mie5p"};